import { ACTION_TYPES } from "reducers/actionTypes";
import api from "ApiClient";

export const getUg = () => {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPES.ug.loading,
    });
    return api
      .get("course-search/undergraduate/ug.json")
      .then((response) => {
        dispatch({
          type: ACTION_TYPES.ug.success,
          payload: { ug: response.data },
        });
      })
      .catch((error) => {
        dispatch({
          type: ACTION_TYPES.ug.failure,
          payload: error,
        });
      });
  };
};
